import { ObjectIdService } from './objectId.service';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.services.objectId', [])
  .service('objectIdService', ObjectIdService).name;
